import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { IconButton } from "@circleco/compass/components/IconButton";

import { useIsAtBottom, useScrollToBottom } from "./threadViewportState";

interface FloatingScrollToBottomButtonProps {
  label: string;
  // Callers with plain bottom-anchored viewports can rely on the defaults
  // below. CircleAi's top-anchor mode distorts the viewport's own isAtBottom
  // and needs to release its anchor pin before scrolling, so it overrides both.
  onScrollToBottom?: () => void;
  visible?: boolean;
}

export const FloatingScrollToBottomButton = ({
  visible,
  label,
  onScrollToBottom,
}: FloatingScrollToBottomButtonProps) => {
  const isAtBottom = useIsAtBottom();
  const scrollToBottom = useScrollToBottom();

  const isVisible = visible ?? !isAtBottom;
  const handleScrollToBottom =
    onScrollToBottom ?? (() => scrollToBottom({ behavior: "smooth" }));

  return (
    <div className="pointer-events-none absolute inset-x-0 -top-12 z-10 flex justify-center">
      <div
        className={classNames(
          "transition-[opacity,transform] duration-200 ease-[cubic-bezier(0.16,1,0.3,1)]",
          { "scale-50 opacity-0": !isVisible },
          { "pointer-events-auto": isVisible },
        )}
      >
        <IconButton
          variant="outline"
          size="md"
          icon="arrow-down"
          aria-label={label}
          onClick={handleScrollToBottom}
        />
      </div>
    </div>
  );
};
